import React, { useEffect, useRef, useState } from 'react';

interface AnimatedNumberProps {
  targetValue: number;
  duration?: number;
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ targetValue, duration = 4000 }) => {
  const [currentValue, setCurrentValue] = useState<number>(0);
  const startTimestampRef = useRef<number | null>(null);

  useEffect(() => {
    let animationFrameId: number;

    const animate = (timestamp: number) => {
      if (startTimestampRef.current === null) {
        startTimestampRef.current = timestamp;
      }

      const elapsed = timestamp - startTimestampRef.current;
      const progress = Math.min(elapsed / duration, 1);
      const value = Math.floor(progress * targetValue);

      setCurrentValue(value);

      if (progress < 1) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrameId);
      startTimestampRef.current = null;
    };
  }, [targetValue, duration]);

  return <p className="!text-sh-md">{currentValue}</p>;
};

export default AnimatedNumber;
